export function normalizeSearchTerm(search) {
  return String(search ?? '').trim().toLowerCase();
}

export function normalizeCouponSerialSearch(search) {
  return String(search ?? '').trim().toUpperCase();
}
